<template>
  <div class="new-one-layer__container">
    <slot></slot>
  </div>
</template>

<script>
// 일단 NewOneLayer를 만들어서 돌파하자
// 왜냐하면 OneLayer는 크기 조정이 가능한걸로 만들어서
// 안에 child template의 크기가 무조건 100%로 조절이 된다

// lottie나 이런것들은 100%이니까 굳이 크기 조절을 할 필요가 없다
export default {};
</script>

<style scoped>
.new-one-layer__container {
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
}
</style>
